<template>
  <div v-if="this.$vuetify.breakpoint.smAndUp">
    <div :class="`fullloadingscreen ${(this.loading===0)?'fade-out-image':''}`">
      <div class="loadingbg-1"></div>
      <div class="loadingbg-2"></div>
      <div class="loadingbg-3"></div>
      <div class="loadingbg-4"></div>
      <div class="text-center fade-in-image">
        <div class="">
          <img src="/img/consark/ConsarkLogo.svg" class="logo-image" alt="logo-image"/>
        </div>
        <img src="/img/loader_new.svg" />
      </div>
    </div>
    <router-view v-if="pass || $store.state.login"></router-view>
    <Login v-else />
  </div>
  <div v-else>
    <div class="smallsize" style="height:100vh">
      <img src="/img/consark/ConsarkLogo.svg" class="logo-image" alt="logo-image"/>
      <span class="pt-4">This application doesn't work on mobile screen size.<br/>Please use a tablet or laptop to proceed</span>
      <a href="consark.ai" class="link">Goto Website</a>
    </div>
  </div>
</template>

<script>
import Login from './views/Auth/Login.vue';

export default {
  components: { Login },
  name: 'App',

  data: () => ({
    pass: false,
    loading: 1,
  }),
  created: function(){
    console.log(process.env.VUE_APP_AUTH_TYPE);

    this.reloadData();
  },
  methods: {
    reloadData: function(){
      let oldpass = this.pass;
      if(window.location.href.substring(100,0).indexOf("/pbc/requestee/") > -1) oldpass = true;
      else if(window.location.href.substring(100,0).indexOf("/setpassword") > -1) oldpass = true;
      else if(window.location.href.substring(100,0).indexOf("/setnewpassword") > -1) oldpass = true;
      else if(window.location.href.substring(100,0).indexOf("/forgotpassword") > -1) oldpass = true;
      else if(window.location.href.substring(100,0).indexOf("/selfservice") > -1) oldpass = true;
      else oldpass = false;
      if(oldpass !== this.pass) {
        this.pass = oldpass;
        if(this.pass){
          this.$store.commit("changeNoAuth", true);
          this.$store.commit("changeLogin", true);
        }else{
          this.$store.commit("changeNoAuth", false);
          this.$store.commit("changeLogin", false);
        }
      }
    },
  },
  watch: {
    "$store.state.loading": function(d){
      this.loading = d;
    },
    $route(to, from) {
      if(from.query.cid !== to.query.cid) {
        // Full page reload on client switch. base.vue's selectedclient
        // watcher handles pre-switch logic (loading state, cycle reset,
        // product access checks, FC landing navigation) before updating
        // the cid in the URL, which triggers this reload.
        this.loading = 1;
        this.$router.go();
      }else if(from.query.cid === undefined) this.reloadData();
    },
  }
};
</script>